/* FRÈRES — Recomendador de talle.
   Compara las medidas del cliente contra la tabla REAL de la prenda
   ([data-szr-table], visible en el modal y parseada acá) o contra la tabla
   general de la marca por categoría (FALLBACK, valores de las guías reales).
   El talle sale de DOS ejes: holgura de pecho/cintura (objetivo según categoría)
   y LARGO de la prenda vs. la altura de la persona (referencia: el largo que la
   prenda tiene pensado para un hombre de 1,76 m, escalado a la altura real).
   Medidas del cliente en localStorage (solo su dispositivo). */
(function () {
  "use strict";
  var ov = document.querySelector("[data-szr-overlay]");
  if (!ov) return;

  var KIND = ov.getAttribute("data-szr-kind") || "auto";
  var EASE = parseFloat(ov.getAttribute("data-szr-ease")) || 12;
  var FBKEY = ov.getAttribute("data-szr-fallback") || "";
  var FITWORD = ov.getAttribute("data-szr-fitword") || "";
  /* Remeras oversize (regla de Lautaro, 28/9): se recomienda el mismo talle que en una
     remera regular, nunca uno menos. Se calcula con la tabla de la remera regular
     (página "Remera regular") y después se ubica ese talle en la tabla de la prenda. */
  var MIRROR = ov.getAttribute("data-szr-mirror") || "";
  var MIRRORS = {
    remera_regular: { mode: "chest", ease: 14, rows: [{ s: "S", v: 51, len: 61 }, { s: "M", v: 55, len: 64 }, { s: "L", v: 57, len: 66 }, { s: "XL", v: 60, len: 68 }] }
  };
  var mirroring = false;
  var LS_KEY = "freres_fit_v1";
  var REF_H = 176, REF_W = 74; /* hombre de referencia para leer la intención de largo de cada tabla */

  /* Tablas generales (cm, medida plana; sin largo) — derivadas de las guías reales. */
  var FALLBACK = {
    top_regular: { mode: "chest", rows: [{ s: "S", v: 51 }, { s: "M", v: 55 }, { s: "L", v: 57 }, { s: "XL", v: 60 }, { s: "XXL", v: 63 }] },
    top_oversize: { mode: "chest", rows: [{ s: "S", v: 55 }, { s: "M", v: 57 }, { s: "L", v: 61 }, { s: "XL", v: 64 }, { s: "XXL", v: 67 }] },
    buzo: { mode: "chest", rows: [{ s: "S", v: 55 }, { s: "M", v: 57 }, { s: "L", v: 59 }, { s: "XL", v: 60 }, { s: "XXL", v: 62 }] },
    bottom: { mode: "waist", rows: [{ s: "38", v: 40 }, { s: "40", v: 41 }, { s: "42", v: 42 }, { s: "44", v: 44 }, { s: "46", v: 47 }, { s: "48", v: 48 }] },
    shoes: { mode: "foot", rows: [{ s: "39", v: 25 }, { s: "40", v: 26 }, { s: "41", v: 26.5 }, { s: "42", v: 27 }, { s: "43", v: 28 }, { s: "44", v: 28.6 }] }
  };
  var LADDER = ["XS", "S", "M", "L", "XL", "XXL", "3XL"];

  function txt(el) { return (el.textContent || "").replace(/\s+/g, " ").trim(); }
  function num(s) { var m = String(s).replace(",", ".").match(/\d+(\.\d+)?/); return m ? parseFloat(m[0]) : NaN; }

  /* ---- Tabla de la prenda (ancho + largo) ---- */
  function parseTable() {
    var src = ov.querySelector("[data-szr-table]");
    if (!src) return null;
    var host = document.createElement("div");
    host.innerHTML = src.innerHTML;
    var table = host.querySelector("table");
    if (!table) return null;
    var trs = Array.prototype.slice.call(table.querySelectorAll("tr"));
    if (trs.length < 2) return null;
    var heads = Array.prototype.slice.call(trs[0].querySelectorAll("th,td")).map(txt);
    /* "Pecho" = pecho; "Ancho" es pecho en prendas de arriba y cintura en pantalones;
       "Cintura" = cintura; "medidas en cm" = plantilla (calzado). El tipo de prenda
       (KIND, por título) desambigua; si no hay tipo, deciden los talles (números = pantalón). */
    var pechoI = -1, anchoI = -1, cintI = -1, cmI = -1, lenCol = -1;
    heads.forEach(function (h, i) {
      var hl = h.toLowerCase();
      if (pechoI < 0 && /pecho/.test(hl)) pechoI = i;
      if (anchoI < 0 && /ancho/.test(hl)) anchoI = i;
      if (cintI < 0 && /cintura/.test(hl)) cintI = i;
      if (cmI < 0 && /cm|plantilla/.test(hl)) cmI = i;
      if (lenCol < 0 && /^largo/.test(hl)) lenCol = i;
    });
    var col = -1, mode = null;
    if (KIND === "shoes" && cmI >= 0) { col = cmI; mode = "foot"; }
    else if (pechoI >= 0) { col = pechoI; mode = "chest"; }
    else if (KIND === "bottom" && (cintI >= 0 || anchoI >= 0)) { col = cintI >= 0 ? cintI : anchoI; mode = "waist"; }
    else if (KIND === "top" && (anchoI >= 0 || cintI >= 0)) { col = anchoI >= 0 ? anchoI : cintI; mode = "chest"; }
    else if (cintI >= 0) { col = cintI; mode = "waist"; }
    else if (anchoI >= 0) { col = anchoI; mode = null; }
    else if (cmI >= 0) { col = cmI; mode = "foot"; }
    if (col < 0) return null;
    var rows = [];
    trs.slice(1).forEach(function (tr) {
      var cells = Array.prototype.slice.call(tr.querySelectorAll("td,th")).map(txt);
      if (!cells.length) return;
      var size = cells[0], val = num(cells[col]);
      var len = lenCol >= 0 ? num(cells[lenCol]) : NaN;
      if (size && !isNaN(val)) rows.push({ s: size.toUpperCase(), v: val, len: isNaN(len) ? null : len });
    });
    if (!rows.length) return null;
    if (!mode) mode = /^\d/.test(rows[0].s) ? "waist" : "chest";
    return { mode: mode, rows: rows };
  }

  var OWN_TABLE = parseTable();
  var TABLE = OWN_TABLE || FALLBACK[FBKEY] || null;
  var USING_FALLBACK = !OWN_TABLE;
  /* Ante la duda, solo la tabla (13/10): si la prenda trae su tabla pero no la podemos
     leer (imagen, columnas raras), no calculamos con la general — mostramos la suya. */
  var HAS_PAGE = !!ov.querySelector("[data-szr-table]");
  /* Score mínimo entre el talle elegido y el siguiente mejor (en cm de contorno).
     Por debajo, la persona queda entre dos talles y preferimos no adivinar. */
  var TIE = 0.3;

  /* ---- Talles del producto en la página ---- */
  function sizeGroups() {
    return Array.prototype.slice.call(document.querySelectorAll("[data-sizes]")).filter(function (g) {
      return g.querySelectorAll("[data-size]").length > 1;
    });
  }
  function optionValues() {
    var vals = [];
    sizeGroups().forEach(function (g) {
      Array.prototype.slice.call(g.querySelectorAll("[data-size]")).forEach(function (b) {
        vals.push(String(b.getAttribute("data-size")).toUpperCase());
      });
    });
    return vals;
  }

  /* Extiende la tabla si el producto vende talles que la tabla no lista (ej. XXL). */
  function extendedRows() {
    var rows = TABLE.rows.map(function (r) { return { s: r.s, v: r.v, len: r.len == null ? null : r.len, est: false }; });
    var opts = optionValues();
    if (rows.length >= 2 && opts.length) {
      var a = rows[rows.length - 2], b = rows[rows.length - 1];
      var step = b.v - a.v;
      if (step <= 0) step = TABLE.mode === "foot" ? 0.6 : 2;
      var lenStep = (a.len != null && b.len != null) ? Math.max(b.len - a.len, 0) : null;
      for (var k = 0; k < 2; k++) {
        var last = rows[rows.length - 1];
        var next = null;
        var li = LADDER.indexOf(last.s);
        if (li >= 0 && li < LADDER.length - 1) next = LADDER[li + 1];
        else if (/^\d+$/.test(last.s)) next = String(parseInt(last.s, 10) + 2);
        if (!next || opts.indexOf(next) < 0) break;
        rows.push({ s: next, v: last.v + step, len: (last.len != null && lenStep != null) ? last.len + lenStep : null, est: true });
      }
    }
    return rows;
  }

  /* ---- Estimación corporal (hombre, aprox.) ---- */
  function estChest(h, w) { return 64.5 - 0.125 * h + 0.75 * w; }
  function estWaist(h, w) { return 45 - 0.15 * h + 0.9 * w; }

  /* ---- Recomendación ---- */
  function recommend(body, height) {
    if (MIRROR && MIRRORS[MIRROR] && TABLE.mode === "chest" && !mirroring) return recommendMirror(body, height);
    var rows = extendedRows();
    if (TABLE.mode === "foot") {
      var pick = null;
      rows.forEach(function (r) { if (!pick && r.v >= body + 0.5) pick = r; });
      var tight = !pick;
      if (!pick) pick = rows[rows.length - 1];
      return { size: pick.s, est: pick.est, doubt: tight || pick.est, verdict: tight ? "Tu pie mide más que nuestro talle más grande — te va a quedar justo." : "Con tu pie de " + String(body).replace(".", ",") + " cm te queda el espacio justo para pisar cómodo.", alt: null };
    }

    function easeScore(r) { return Math.abs(r.v * 2 - body - EASE); }
    /* Mejor talle por holgura pura (referencia para el mensaje). */
    var easeBest = null;
    rows.forEach(function (r) { if (!easeBest || easeScore(r) <= easeScore(easeBest)) easeBest = r; });

    /* Eje largo: qué largo tiene pensado la prenda para 1,76 m, escalado a la altura real. */
    var hasLen = rows.length > 0 && rows.every(function (r) { return r.len != null; });
    var idealLen = null, lenW = 0;
    if (hasLen && height) {
      var refBody = TABLE.mode === "waist" ? estWaist(REF_H, REF_W) : estChest(REF_H, REF_W);
      var refPick = null, refBest = 1e9;
      rows.forEach(function (r) { var sc = Math.abs(r.v * 2 - refBody - EASE); if (sc < refBest) { refBest = sc; refPick = r; } });
      idealLen = refPick.len * (height / REF_H);
      lenW = TABLE.mode === "waist" ? 0.8 : (FITWORD === "oversize" ? 2 : 1.5);
    }
    function score(r) { return easeScore(r) + (idealLen != null ? lenW * Math.abs(r.len - idealLen) : 0); }

    var best = null;
    rows.forEach(function (r) {
      if (!best) { best = r; return; }
      var d = score(r) - score(best);
      if (d < -0.001) best = r;
      else if (Math.abs(d) <= 0.001) {
        /* Empate: gana el largo más acorde a la altura; sin dato de largo, el más grande. */
        if (idealLen != null) { if (Math.abs(r.len - idealLen) < Math.abs(best.len - idealLen)) best = r; }
        else if (easeScore(r) <= easeScore(best)) best = r;
      }
    });
    if (idealLen == null && easeBest) best = easeBest;

    /* Margen contra el segundo mejor talle, con el mismo criterio con que se eligió. */
    var used = idealLen != null ? score : easeScore, margin = 1e9;
    rows.forEach(function (r) { if (r !== best) margin = Math.min(margin, used(r) - used(best)); });

    var d = best.v * 2 - body - EASE;
    var where = TABLE.mode === "waist" ? "en la cintura" : "";
    var verdict;
    if (d < -8) verdict = ("Te va a quedar ajustado " + where).trim() + ". Si estás entre dos, andá al más grande.";
    else if (d < -3) verdict = ("Te va a quedar un poco más al cuerpo que en las fotos " + where).trim() + ".";
    else if (d <= 3) verdict = "Calce como en las fotos.";
    else if (d <= 8) verdict = ("Te va a quedar un poco holgado " + where).trim() + ".";
    else verdict = ("Te va a quedar bien holgado " + where).trim() + ".";

    var bi = rows.indexOf(best), ei = rows.indexOf(easeBest);
    if (ei > bi) verdict += " Por tu altura te conviene este y no uno más grande: el largo te queda mejor.";
    else if (ei < bi) verdict += " Por tu altura subimos un talle: el largo te acompaña mejor.";
    if (FITWORD === "oversize") verdict += " Este modelo es oversize: el calce suelto es parte del diseño.";

    /* Regla de la marca (Lautaro, 28/7): en prendas regulares la alternativa es un
       talle MÁS (por si lo quiere holgado); en oversize, un talle MENOS (por si no
       lo quiere tan grande). */
    var alt = null;
    if (FITWORD === "oversize") {
      if (bi > 0 && d >= -8) alt = "¿No lo querés tan grande? Llevá " + rows[bi - 1].s + ".";
    } else if (bi < rows.length - 1 && d <= 8) {
      alt = "¿Lo preferís más holgado? Llevá " + rows[bi + 1].s + ".";
    }
    /* Dudoso: talle extrapolado, fuera de la tabla por arriba o por abajo, o empate. */
    var doubt = best.est || d < -8 || (bi === 0 && d > 8) || margin < TIE;
    return { size: best.s, est: best.est, doubt: doubt, margin: margin, verdict: verdict, alt: alt };
  }

  function recommendMirror(body, height) {
    var m = MIRRORS[MIRROR], keep = [TABLE, EASE, FITWORD], r;
    TABLE = m; EASE = m.ease; FITWORD = ""; mirroring = true;
    try { r = recommend(body, height); }
    finally { TABLE = keep[0]; EASE = keep[1]; FITWORD = keep[2]; mirroring = false; }
    var rows = extendedRows(), i = -1, doubt = r.doubt;
    rows.forEach(function (x, k) { if (x.s === r.size) i = k; });
    if (i < 0) {
      doubt = true;
      /* El talle regular no existe en esta prenda: el más cercano en la escala. */
      var want = LADDER.indexOf(r.size), last = LADDER.indexOf(rows[rows.length - 1].s);
      i = (want >= 0 && last >= 0 && want > last) ? rows.length - 1 : 0;
    }
    return {
      size: rows[i].s,
      est: rows[i].est,
      doubt: doubt || rows[i].est,
      verdict: "Llevá el mismo talle que usás en una remera regular. Este modelo es oversize: el calce suelto es parte del diseño.",
      alt: i > 0 ? "¿No lo querés tan grande? Llevá " + rows[i - 1].s + "." : null
    };
  }

  /* ---- Disponibilidad del talle sugerido en ESTE producto ---- */
  function availability(size) {
    var jsonEl = document.querySelector("[data-variants-json]");
    var groups = sizeGroups();
    if (!jsonEl || groups.length !== 1) return { known: false };
    var idx = parseInt(groups[0].getAttribute("data-option-index"), 10) || 0;
    try {
      var variants = JSON.parse(jsonEl.textContent);
      var found = false, avail = false;
      variants.forEach(function (v) {
        if (String(v.options[idx]).toUpperCase() === size) { found = true; if (v.available) avail = true; }
      });
      return { known: found, available: avail, group: groups[0], idx: idx };
    } catch (e) { return { known: false }; }
  }

  /* ---- Storage ---- */
  function loadFit() { try { return JSON.parse(localStorage.getItem(LS_KEY) || "null"); } catch (e) { return null; } }
  function saveFit(f) { try { localStorage.setItem(LS_KEY, JSON.stringify(f)); } catch (e) {} }

  /* ---- UI ---- */
  var form = ov.querySelector("[data-szr-form]");
  var result = ov.querySelector("[data-szr-result]");
  var errEl = ov.querySelector("[data-szr-err]");
  var iH = ov.querySelector("[data-szr-h]"), iW = ov.querySelector("[data-szr-w]");
  var iChest = ov.querySelector("[data-szr-chest]"), iWaist = ov.querySelector("[data-szr-waist]"), iFoot = ov.querySelector("[data-szr-foot]");

  /* Barras deslizables: el valor grande se actualiza en vivo. */
  function fmtVal(v, unit) { return String(v).replace(".", ",") + " " + unit; }
  function syncOuts() {
    [[iH, "[data-szr-h-out]", "cm"], [iW, "[data-szr-w-out]", "kg"], [iFoot, "[data-szr-foot-out]", "cm"]].forEach(function (p) {
      var out = ov.querySelector(p[1]);
      if (p[0] && out) out.textContent = fmtVal(p[0].value, p[2]);
    });
  }
  [iH, iW, iFoot].forEach(function (inp) { if (inp) inp.addEventListener("input", syncOuts); });
  syncOuts();

  /* Si mueve altura/peso, el contorno tipeado en otra visita deja de valer:
     lo borramos para que no pise a las barras en silencio. */
  var slidersTouched = false;
  [iH, iW].forEach(function (inp) {
    if (inp) inp.addEventListener("input", function () {
      slidersTouched = true;
      if (iChest) iChest.value = "";
      if (iWaist) iWaist.value = "";
    });
  });

  function openOv() { ov.classList.add("is-on"); document.documentElement.style.overflow = "hidden"; }
  function closeOv() { ov.classList.remove("is-on"); document.documentElement.style.overflow = ""; }

  function bodyMeasure() {
    if (TABLE.mode === "foot") {
      var f = iFoot ? parseFloat(iFoot.value) : NaN;
      return (f >= 20 && f <= 35) ? f : null;
    }
    var h = iH ? parseFloat(iH.value) : NaN, w = iW ? parseFloat(iW.value) : NaN;
    var direct = TABLE.mode === "waist" ? (iWaist && parseFloat(iWaist.value)) : (iChest && parseFloat(iChest.value));
    if (direct && direct > 50 && direct < 170) return direct;
    if (!(h >= 140 && h <= 220) || !(w >= 40 && w <= 180)) return null;
    return TABLE.mode === "waist" ? estWaist(h, w) : estChest(h, w);
  }

  /* Talle que la prenda no vende (ej. XL en un modelo que llega a L): también es duda. */
  function notSold(size) {
    var opts = optionValues();
    return opts.length > 0 && opts.indexOf(size) < 0;
  }

  /* Sin sugerencia: la explicación y la tabla abierta, sin talle ni chip. */
  function showDoubt() {
    var sizeEl = ov.querySelector("[data-szr-size]");
    sizeEl.textContent = ""; sizeEl.hidden = true;
    ov.querySelector("[data-szr-verdict]").textContent = "Con estas medidas no te podemos sugerir un talle seguro en esta prenda. Fijate en la tabla de abajo: compará con una prenda tuya que te quede bien, apoyada sobre la mesa. Si dudás entre dos, andá al más grande.";
    ov.querySelector("[data-szr-alt]").hidden = true;
    ov.querySelector("[data-szr-pick]").hidden = true;
    var det = ov.querySelector(".szr-tabla");
    if (det) det.open = true;
    form.hidden = true; result.hidden = false;
    if (hintEl) hintEl.hidden = true;
  }

  function showResult(rec) {
    if (rec.doubt || notSold(rec.size)) return showDoubt();
    ov.querySelector("[data-szr-size]").hidden = false;
    var av = availability(rec.size);
    ov.querySelector("[data-szr-size]").textContent = rec.size;
    var verdict = rec.verdict;
    if (rec.est) verdict += " (Talle estimado: la tabla de esta prenda llega hasta un talle menos.)";
    if (USING_FALLBACK) verdict += " Calculado con la tabla general de la marca.";
    var altEl = ov.querySelector("[data-szr-alt]");
    var pickBtn = ov.querySelector("[data-szr-pick]");
    if (av.known && !av.available) {
      verdict += " Ojo: este talle está agotado en este producto ahora mismo.";
      altEl.hidden = true; pickBtn.hidden = true;
    } else {
      altEl.textContent = rec.alt || ""; altEl.hidden = !rec.alt;
      if (av.known && av.available) {
        pickBtn.hidden = false;
        pickBtn.textContent = "Elegir talle " + rec.size;
        pickBtn.onclick = function () {
          var btns = av.group.querySelectorAll("[data-size]");
          Array.prototype.forEach.call(btns, function (b) {
            if (String(b.getAttribute("data-size")).toUpperCase() === rec.size) b.click();
          });
          closeOv();
        };
      } else pickBtn.hidden = true;
    }
    ov.querySelector("[data-szr-verdict]").textContent = verdict;
    form.hidden = true; result.hidden = false;
    refreshHint(rec.size);
  }

  function calc(silent) {
    var body = bodyMeasure();
    if (body == null) {
      if (!silent && errEl) { errEl.textContent = "Completá los datos para poder calcular."; errEl.hidden = false; }
      return false;
    }
    if (errEl) errEl.hidden = true;
    var fit = loadFit() || {};
    if (iH && iH.value) fit.h = parseFloat(iH.value);
    if (iW && iW.value) fit.w = parseFloat(iW.value);
    if (slidersTouched) { delete fit.chest; delete fit.waist; }
    if (iChest && iChest.value) fit.chest = parseFloat(iChest.value);
    if (iWaist && iWaist.value) fit.waist = parseFloat(iWaist.value);
    if (iFoot && iFoot.value) fit.foot = parseFloat(iFoot.value);
    saveFit(fit);
    var height = iH ? parseFloat(iH.value) : null;
    showResult(recommend(Math.round(body * 10) / 10, height));
    return true;
  }

  form.addEventListener("submit", function (e) { e.preventDefault(); calc(false); });
  ov.querySelector("[data-szr-again]").addEventListener("click", function () { result.hidden = true; form.hidden = false; });
  ov.addEventListener("click", function (e) { if (e.target === ov) closeOv(); });
  ov.querySelector("[data-szr-close]").addEventListener("click", closeOv);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeOv(); });

  function prefill() {
    var fit = loadFit();
    if (!fit) return false;
    if (iH && fit.h) iH.value = fit.h;
    if (iW && fit.w) iW.value = fit.w;
    if (iChest && fit.chest) iChest.value = fit.chest;
    if (iWaist && fit.waist) iWaist.value = fit.waist;
    if (iFoot && fit.foot) iFoot.value = fit.foot;
    syncOuts();
    return true;
  }

  /* Chip "Sugerido para vos: M" bajo los talles (visitas siguientes). */
  var hintEl = null;
  function refreshHint(size) {
    if (!hintEl) return;
    hintEl.querySelector("strong").textContent = size;
    hintEl.hidden = false;
  }

  /* Modo "solo tabla": misma ventana, sin formulario ni sugerencia (lo oculta el CSS
     de .szr-overlay--tabla, que se imprime siempre desde el snippet). */
  function tableMode() {
    ov.classList.add("szr-overlay--tabla");
    ov.setAttribute("aria-label", "Tabla de medidas");
    var det = ov.querySelector(".szr-tabla");
    if (det) det.open = true;
  }

  function init() {
    var groups = sizeGroups();
    if (!groups.length) return;
    var opts = optionValues();
    /* Dudas que se ven antes de calcular nada → solo la tabla de la prenda:
       - no hay tabla legible (o es la general de la marca, no la de la prenda)
       - varios selectores de talle (packs: cada prenda tiene su tabla)
       - talles dobles tipo "S-M"
       - los talles de la tabla no se cruzan con los que vende el producto */
    var solo = ov.classList.contains("szr-overlay--tabla");
    if (!TABLE || USING_FALLBACK) {
      if (!HAS_PAGE) return;
      solo = true;
    }
    if (groups.length > 1) solo = true;
    if (opts.some(function (o) { return /\w-\w/.test(o); })) solo = true;
    if (!solo && TABLE.mode !== "foot") {
      var overlap = extendedRows().some(function (r) { return opts.indexOf(r.s) >= 0; });
      if (!overlap) {
        if (!HAS_PAGE) return;
        solo = true;
      }
    }
    if (solo) tableMode();
    var block = groups[0].closest(".pinfo-block");
    var lbl = block && block.querySelector(".pinfo-label");
    if (lbl && !lbl.querySelector("[data-szr-open]")) {
      var a = document.createElement("button");
      a.type = "button"; a.className = "pinfo-szr-link"; a.setAttribute("data-szr-open", "");
      /* En las prendas marcadas con el tag `sin-recomendador` la ventana muestra solo la
         tabla, así que el enlace no puede prometer una sugerencia que no va a dar. */
      a.textContent = solo ? "Tabla de medidas" : "¿Cuál es mi talle?";
      lbl.appendChild(a);
    }
    if (solo) {
      /* Sin chip "Sugerido para vos" ni cálculo con las medidas guardadas. */
      document.addEventListener("click", function (e) {
        if (e.target.closest("[data-szr-open]")) { e.preventDefault(); openOv(); }
      });
      return;
    }
    if (block && !block.querySelector(".szr-hint")) {
      hintEl = document.createElement("p");
      hintEl.className = "szr-hint"; hintEl.hidden = true;
      hintEl.innerHTML = "Sugerido para vos: <strong></strong><button type=\"button\" data-szr-open>ajustar</button>";
      block.appendChild(hintEl);
    }
    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-szr-open]")) {
        e.preventDefault();
        openOv();
        if (result.hidden && prefill()) calc(true);
      }
    });
    /* Con medidas guardadas, calculamos en silencio: aparece el chip bajo los
       talles y, si abre el modal, ve su resultado directo. */
    if (prefill()) calc(true);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
